// Menu chính của 3D, dùng chung cho menu ngang (App.js) và menu ☰ thu gọn trên màn hẹp (Giao may ảnh).
// exact: false → NavLink active cả route con; adminOnly: chỉ fac_admin; tooltip: chú thích khi hover (desktop).
export const MAIN_MENU_ITEMS = [
    { to: '/dashboard', label: 'Dashboard' },
    { to: '/', label: 'Home' },
    { to: '/labels', label: 'Labels' },
    { to: '/baskets', label: 'Baskets', exact: false },
    { to: '/merger', label: 'Gộp đơn' },
    { to: '/updatebatches', label: 'Cập nhật trạng thái Lô' },
    { to: '/sewing-group', label: 'Nhóm may' },
    // Màn của FAC-26608 (route khai báo ở nhánh đó) — giữ đúng vị trí như menu trên release
    { to: '/sewing-handover/history', label: 'Lịch sử giao may' },
    { to: '/batches', label: 'Lô' },
    { to: '/laze-cutting', label: 'Cắt Laze' },
    { to: '/mex', label: 'Ép Mex' },
    { to: '/mark-periods', label: 'Hoàn thiện' },
    { to: '/sewing-repair', label: 'Sửa may' },
    { to: '/embroidery', label: 'Thêu' },
    { to: '/embroidery-error', label: 'Lỗi thêu' },
    { to: '/markitemprinted', label: 'QC sau ép' },
    { to: '/merger-set', label: 'Gộp SET' },
    { to: '/batches/mark-qc', label: 'QC hoàn thành' },
    { to: '/request-photo', label: 'Chụp ảnh' },
    { to: '/sewing-handover', label: 'Giao may ảnh' },
    { to: '/orders/packing', label: 'Đóng gói', tooltip: 'Đóng gói theo đơn' },
    { to: '/partners', label: 'Đối tác' },
    { to: '/group-batch', label: 'Gom nhóm lô' },
    { to: '/attach-tag', label: 'Gắn tag mác' },
    { to: '/original-file-management', label: 'Quản lý file in theo hệ màu và máy in', adminOnly: true },
    { to: '/fba-item-design', label: 'Items FBA theo design' },
    { to: '/sewing-thread-color', label: 'Màu chỉ may' },
]

// Các mục trong dropdown "Khác"
export const OTHER_MENU_ITEMS = [
    { to: '/order-item', label: 'Order item' },
    { to: '/order-label', label: 'Order label' },
    { to: '/in-card', label: 'In card' },
    { to: '/list-rule-create-batch', label: 'Rule tạo lô' },
    { to: '/reuse-embroidery-info', label: 'Thiết kế thêu' },
    { to: '/color-check-items', label: 'Kiểm soát hệ màu' },
]

export const filterMenuItems = (items, isAdmin) => items.filter(item => !item.adminOnly || isAdmin)
